import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

/** layout used to load screens before the user is fully allowed to use the application, ex:user-agreement */
@Component({
    selector: 'app-unauthenticated-layout',
    templateUrl: './unauthenticated-layout.component.html',
    styleUrl: './unauthenticated-layout.component.scss',
    standalone: true,
    imports:[RouterOutlet]
})
export class UnauthenticatedLayoutComponent {

}
